<template>
  <v-container class="pa-4">
    <div class="pt-4 pb-6">
      <v-btn text ref="button-toolbar-close" @click="$emit('close')">
        <v-icon>close</v-icon>
        <span>{{ $t("general.close") }}</span>
      </v-btn>
    </div>
    <v-row class="px-4">
      <v-col cols="12">
        <v-card class="rounded-lg pa-4" flat>
          <v-card-title class="justify-center">
            {{ $t("organization.details.tabs.account.title") }}
          </v-card-title>
          <v-card-text class="d-flex flex-column justify-center align-center">
            <p
              class="body-2 grey--text text-center text--darken-2"
              style="max-width: 400px;"
            >
              {{ $t("organization.details.tabs.account.description") }}
            </p>
            <p
              class="text-color font-weight-medium mt-6"
              style="font-size: 18px;"
            >
              {{ $t("organization.details.tabs.account.selected_plans") }}
            </p>
          </v-card-text>

          <v-card
            flat
            class="rounded-lg card-border"
            v-if="organizationPlan && organizationPlan.id"
          >
            <v-card-title
              class="body-1 font-weight-medium"
              @click="toggleLicensePlan"
            >
              {{ organizationPlan.plan.display_name }}
              <v-spacer />
              <v-icon>
                {{ cardLicenseExpanded ? "arrow_drop_up" : "arrow_drop_down" }}
              </v-icon>
            </v-card-title>
            <v-divider />
            <v-expand-transition>
              <v-card v-show="cardLicenseExpanded" flat>
                <v-card-text>
                  <v-row class="ml-2">
                    <v-col cols="12" md="6">
                      <p class="body-2 grey--text text--darken-2">
                        {{ $t("subscriptions.dashboard.timestamp") }}
                      </p>
                      <p class="black--text">
                        {{
                          $moment(organizationPlan.created_at).format(
                            "DD/MM/YYYY"
                          )
                        }}
                      </p>
                    </v-col>
                    <v-col cols="12" md="6">
                      <p class="body-2 grey--text text--darken-2">
                        {{
                          $t("organization.details.tabs.account.change_date")
                        }}
                      </p>
                      <p class="black--text">
                        {{
                          $moment(organizationPlan.updated_at).format(
                            "DD/MM/YYYY"
                          )
                        }}
                      </p>
                    </v-col>
                    <v-col cols="12" md="6">
                      <p class="body-2 grey--text text--darken-2">
                        {{ $t("organization.details.tabs.account.new_plan") }}
                      </p>
                      <p class="black--text">
                        {{ organizationPlan.plan.display_name }}
                      </p>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expand-transition>
            <v-card-title
              v-if="organizationPlan.plan_automation"
              class="body-1 font-weight-medium"
              @click="toggleAutomationPlan"
            >
              {{
                organizationPlan.plan_automation
                  ? organizationPlan.plan_automation.display_name
                  : "-"
              }}
              <v-spacer />
              <v-icon>
                {{
                  cardAutomationExpanded ? "arrow_drop_up" : "arrow_drop_down"
                }}
              </v-icon>
            </v-card-title>
            <v-divider />
            <v-expand-transition v-if="organizationPlan.plan_automation">
              <v-card v-show="cardAutomationExpanded" flat>
                <v-card-text>
                  <v-row class="ml-2">
                    <v-col cols="12" md="6">
                      <p class="body-2 grey--text text--darken-2">
                        {{ $t("subscriptions.dashboard.timestamp") }}
                      </p>
                      <p class="black--text">
                        {{
                          $moment(organizationPlan.created_at).format(
                            "DD/MM/YYYY"
                          )
                        }}
                      </p>
                    </v-col>
                    <v-col cols="12" md="6">
                      <p class="body-2 grey--text text--darken-2">
                        {{
                          $t("organization.details.tabs.account.change_date")
                        }}
                      </p>
                      <p class="black--text">
                        {{
                          $moment(organizationPlan.updated_at).format(
                            "DD/MM/YYYY"
                          )
                        }}
                      </p>
                    </v-col>
                    <v-col cols="12" md="6">
                      <p class="body-2 grey--text text--darken-2">
                        {{ $t("organization.details.tabs.account.new_plan") }}
                      </p>
                      <p class="black--text">
                        {{
                          organizationPlan.plan_automation
                            ? organizationPlan.plan_automation.display_name
                            : "-"
                        }}
                      </p>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expand-transition>
          </v-card>
          <v-card
            flat
            class="rounded-lg"
            v-else
            style="border: 1px solid #d0d3db"
          >
            <v-card-title
              class="body-1 grey--text text--darken-2 justify-center"
            >
              {{ $t("organization.details.tabs.account.no_plans") }}
            </v-card-title>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "AccountDetails",
  data() {
    return {
      cardLicenseExpanded: false,
      cardAutomationExpanded: false
    };
  },
  computed: {
    ...mapState({
      organizationPlan: ({ organization: { organizationPlan } }) =>
        organizationPlan
    })
  },
  methods: {
    toggleLicensePlan() {
      this.cardLicenseExpanded = !this.cardLicenseExpanded;
    },
    toggleAutomationPlan() {
      this.cardAutomationExpanded = !this.cardAutomationExpanded;
    }
  }
};
</script>

<style lang="scss" scoped>
.text-color {
  color: #2661ff;
}
.card-border {
  border: 1px solid #d0d3db;
}
</style>
